import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigQuery } from '../../../core/state/app-config/app-config.query';
import { TagsStore } from './tags.store';
import { SessionQuery } from '../../../core/state/session/session.query';
import { TagResponse } from './tags.model';
import { forkJoin } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NewTagsService {
    constructor(
        private _config: AppConfigQuery,
        private _http: HttpClient,
        private _tagsStore: TagsStore,
        private _sessionQuery: SessionQuery
    ) {}

    get() {
        return this._http
            .get<Array<TagResponse>>(
                `${this._config.get()?.sharedResourceBaseUrl}/api/tag/v1`
            )
            .pipe(
                tap((tags) => {
                    //const mergedTags = mergeTags(tags);
                    this._tagsStore.set(tags);
                })
            );
    }

    add({
        ...params
    }: Omit<
        TagResponse,
        'id' | 'updatedAt' | 'createdAt' | 'updatedBy' | 'createdBy' | 'userId'
    > & {
        //accountId?: Acct['accountId'];
    }) {
        // TODO: remove ownerId as required field as it should be possible to re-use the same tag for multiple legal entities/owners given they are in the same "tenant group"
        // TODO: remove itemId as required field as it should be possible to create a tag without an item
        return this._http
            .post(`${this._config.get()?.sharedResourceBaseUrl}/api/tag/v1`, {
                ...params,
                ownerId: params.ownerId || this._sessionQuery.primaryOwnerId,
                itemId: params.itemId,
                itemType: params.itemType || 'instrument'
            })
            .pipe(
                tap((tag: TagResponse) => {
                    this._tagsStore.add(tag);
                })
            );
    }

    /*add({
        ...params
    }: Omit<NewTag, 'id' | 'createdByUserId' | 'createdDate'> & {
        accountId?: Acct['accountId'];
    }) {
        const newTag = createNewTag({
            ...params,
            createdByUserId: this._sessionQuery.user.details.decodedDetails.user_name
        });

        this._tagsStore.upsert(newTag.id, (entity: NewTag) => {
            if (newTag.accountIds && entity.accountIds) {
                newTag.accountIds = [...(entity.accountIds || []), ...newTag.accountIds];
            }
            return {
                ...entity,
                ...newTag
            };
        });
        return of(newTag).pipe(delay(0), take(1));
    }*/

    remove(ids: Array<TagResponse['id']>) {
        // if multiple ids are passed...
        if (ids.length > 1) {
            const requests$ = ids.map((id) =>
                this._http.delete<TagResponse>(
                    `${this._config.get()?.sharedResourceBaseUrl}/api/tag/v1/`,
                    { params: { id } }
                )
            );
            return forkJoin(requests$).pipe(
                tap(() => {
                    this._tagsStore.remove(ids);
                }),
                map(([...res]) => res)
            );
            // TODO: implement batch delete
        } else {
            return this._http
                .delete<TagResponse>(
                    `${this._config.get()?.sharedResourceBaseUrl}/api/tag/v1/`,
                    {
                        params: {
                            id: ids[0]
                        }
                    }
                )
                .pipe(
                    tap(() => {
                        this._tagsStore.remove(ids[0]);
                    }),
                    map((res) => [res])
                );
        }
    }

    update(id: TagResponse['id'], { ...params }: Partial<TagResponse>) {
        return this._http
            .patch(
                `${this._config.get()?.sharedResourceBaseUrl}/api/tag/v1/`,
                {
                    ...params
                },
                {
                    params: {
                        id
                    }
                }
            )
            .pipe(
                tap((tag: TagResponse) => {
                    this._tagsStore.update(id, (entity) => ({
                        ...tag
                    }));
                })
            );
    }

    /*remove(id: NewTag['id'], { ...options }: { accountId?: Acct['accountId'] } = {}) {
        if (options.accountId) {
            this._tagsStore.update(id, (entity) => {
                return {
                    ...entity,
                    accountIds: entity.accountIds?.filter((a) => a !== options.accountId)
                };
            });
        }
        return of(null);
    }*/
}
